import { render, staticRenderFns } from "./KnowledgeFeedUser.vue?vue&type=template&id=38636ee1&scoped=true&"
import script from "./KnowledgeFeedUser.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFeedUser.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeFeedUser.vue?vue&type=style&index=0&lang=css&"
import style1 from "./KnowledgeFeedUser.vue?vue&type=style&index=1&id=38636ee1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38636ee1",
  null
  
)

export default component.exports